<template>
  <div class="p-6">
    <h2 class="text-xl font-bold mb-4">Create Invoice</h2>

    <!-- Invoice Header -->
    <div class="invoice-header">
      <!-- Invoice Number -->
      <div class="form-group">
        <label for="invoice_number">Invoice Number</label>
        <input
          id="invoice_number"
          v-model="form.invoice_number"
          placeholder="Invoice Number"
        />
      </div>

      <!-- Patient Name -->
      <div class="form-group">
        <label for="patient_name">Patient Name</label>
        <input
          id="patient_name"
          v-model="form.patient_name"
          placeholder="Patient Name"
        />
      </div>

      <!-- Patient Number -->
      <div class="form-group">
        <label for="patient_number">Patient Number</label>
        <input
          id="patient_number"
          v-model="form.patient_number"
          placeholder="Patient Number"
        />
      </div>

      <!-- Age -->
      <div class="form-group">
        <label for="age">Age</label>
        <input
          id="age"
          v-model="form.age"
          placeholder="Patient Age"
          type="number"
        />
      </div>

      <!-- Visit Type -->
      <div class="form-group">
        <label for="visit_type">Visit Type</label>
        <input
          id="visit_type"
          v-model="form.visit_type"
          placeholder="Visit Type"
        />
      </div>

      <!-- Insurer Name -->
      <div class="form-group">
        <label for="insurer_name">Insurer Name</label>
        <input
          id="insurer_name"
          v-model="form.insurer_name"
          placeholder="Insurer Name"
        />
      </div>

      <!-- Visit Date -->
      <div class="form-group full-width">
        <label for="visit_date">Visit Date</label>
        <input id="visit_date" v-model="form.visit_date" type="date" />
      </div>
    </div>

    <!-- Invoice Details Table -->
    <table class="w-full border mb-4">
      <thead>
        <tr class="bg-gray-200">
          <th class="p-2">Service / Product</th>
          <th class="p-2">Quantity</th>
          <th class="p-2">Unit Price</th>
          <th class="p-2">Amount</th>
          <th class="p-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in form.items" :key="index">
          <td>
            <input v-model="row.service_name" class="border p-2 w-full" />
          </td>
          <td>
            <input
              type="number"
              v-model.number="row.quantity"
              @input="calculateRow(index)"
              class="border p-2 w-full"
            />
          </td>
          <td>
            <input
              type="number"
              v-model.number="row.unit_price"
              @input="calculateRow(index)"
              class="border p-2 w-full"
            />
          </td>
          <td>{{ row.amount }}</td>
          <td>
            <button
              @click="removeRow(index)"
              class="btn-danger bg-red-500 text-white px-2 py-1 rounded"
            >
              Remove
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <button
      @click="addRow"
      class="btn-primary bg-blue-600 text-white px-4 py-2 rounded mb-4"
    >
      + Add Row
    </button>

    <!-- Totals -->
    <div class="flex justify-end mb-4">
      <div class="text-right">
        <p class="font-bold">Total: {{ grandTotal }}</p>
      </div>
    </div>

    <!-- Submit -->
    <button
      @click="submitInvoice"
      class="btn-secondary bg-green-600 text-white px-6 py-2 rounded"
    >
      Save Invoice
    </button>
  </div>
</template>

<script>
// import axios from "axios";
import { generalApiRequest } from "../../../api/apiIndex";
import showNotification from "../../../notification/notify";

export default {
  name: "OffCourseInvoiceCreate",
  data() {
    return {
      form: {
        invoice_number: "",
        patient_name: "",
        patient_number: "",
        age: "",
        visit_type: "",
        insurer_name: "",
        visit_date: "", // 👈 added here
        items: [{ service_name: "", quantity: 1, unit_price: 0, amount: 0 }],
      },
    };
  },
  computed: {
    grandTotal() {
      return this.form.items.reduce((sum, item) => sum + (item.amount || 0), 0);
    },
  },
  methods: {
    addRow() {
      this.form.items.push({
        service_name: "",
        quantity: 1,
        unit_price: 0,
        amount: 0,
      });
    },
    removeRow(index) {
      this.form.items.splice(index, 1);
    },
    calculateRow(index) {
      let row = this.form.items[index];
      row.amount = row.quantity * row.unit_price;
    },
    // async submitInvoice() {
    //   const payload = { ...this.form, total_amount: this.grandTotal };
    //   await generalApiRequest("invoices/offcourse/", "POST", payload, 1);
    //   showNotification("SuccessfullyCreated!!");
    // },
    async submitInvoice() {
      try {
        const payload = { ...this.form, total_amount: this.grandTotal };
        await generalApiRequest("invoices/offcourse/", "POST", payload, 1);

        showNotification("Successfully Created!!");

        // ✅ Redirect after success
        this.$router.push({ name: "Off-Course Invoices" });
        // OR: this.$router.push("/invoices/offcourse");
      } catch (error) {
        console.error("Failed to submit invoice:", error);
        showNotification(
          "Failed to create invoice. Please try again.",
          "error"
        );
      }
    },
  },
};
</script>

<style scoped>
.invoice-header {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.form-group input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus {
  border-color: #3b82f6; /* blue highlight */
  box-shadow: 0 0 4px rgba(59, 130, 246, 0.3);
  outline: none;
}

.full-width {
  grid-column: span 2;
}
</style>
